import React from 'react'
import { usePageWrapperStyles } from './page-wrapper.styles'
import { Container, Typography } from '@material-ui/core'
import { Breadcrumbs, BreadcrumbItem } from '../breadcrumbs'

type PageWrapperProps = {
  children: React.ReactNode
  title: string
  titleClassName?: string
  /**
   * Optional content on the same row as the title (e.g. actions, filters).
   * Lays out in one horizontal line: title on the start, this block on the end, full width.
   */
  titleEndContent?: React.ReactNode
  displayGoBackButton: boolean
  goBackNavPath?: string
  goBackClassName?: string
  secondaryHeaderClassName?: string
  headerElement?: React.ReactNode
  /** When set and non-empty, breadcrumbs are rendered */
  breadcrumbItems?: BreadcrumbItem[]
}

/*Wrapper component for setting common styles for all pages in the account section*/
export const PageWrapper: React.FC<PageWrapperProps> = (
  props: PageWrapperProps
): React.ReactElement => {
  const {
    children,
    title,
    titleClassName,
    titleEndContent,
    headerElement,
    breadcrumbItems,
  } = props

  const classes = usePageWrapperStyles()
  return (
    <div className={classes.pageWrapper}>
      <Container>
        <div>
          {breadcrumbItems && breadcrumbItems.length > 0 ? (
            <Breadcrumbs items={breadcrumbItems} />
          ) : null}
          {headerElement ? <div>{headerElement}</div> : <></>}
          {title || titleEndContent ? (
            <div
              className={[
                classes.titleRow,
                !title && titleEndContent ? classes.titleRowEndOnly : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {title ? (
                <Typography
                  className={[classes.pageTitle, titleClassName]
                    .filter(Boolean)
                    .join(' ')}
                  variant="inherit"
                  component="h2"
                >
                  {title}
                </Typography>
              ) : null}
              {titleEndContent ? (
                <div className={classes.titleEnd}>{titleEndContent}</div>
              ) : null}
            </div>
          ) : null}
        </div>
        <div>{children != null ? children : <></>}</div>
      </Container>
    </div>
  )
}
